import React from 'react'

import {
  T_Filter,
  T_FilterSection,
  useFiltersStore,
} from '../state/filtersStore'

const FilterSectionsHeader = () => {
  const appliedFilters = useFiltersStore((state) => state.appliedFilters)
  const resetAppliedFilters = useFiltersStore(
    (state) => state.resetAppliedFilters
  )
  const setGuideUsed = useFiltersStore((state) => state.setGuideUsed)

  return (
    <div className='filter-sections-header'>
      <div className='filter-sections-header__title-wrapper'>
        <i className='fa-solid fa-filter'></i>
        <p>Filter</p>
      </div>

      <div className='filter-sections-header__reset-wrapper'>
        <p>Add filter parameters to refine your search</p>
        {appliedFilters && appliedFilters.length > 0 && (
          <button
            onClick={() => {
              resetAppliedFilters()
              setGuideUsed(false)
            }}
          >
            Reset
          </button>
        )}
      </div>
    </div>
  )
}

export { FilterSectionsHeader }
